import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/auth.store';
import { homeFor } from './AuthGuard';

/** /admin → landing page matching the role. */
export function RoleHome() {
  const role = useAuthStore((s) => s.user?.role);
  return <Navigate to={homeFor(role)} replace />;
}
